



























import type { PropType } from '@nuxtjs/composition-api';
import { computed } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import type { HeadingData } from '~/diptyqueTheme/composable/useFlexibleSection/types';

export default defineComponent({
  components: {
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoTruncatedText: () => import('atoms/VaimoTruncatedText.vue'),
    VaimoButtons: () => import('molecules/VaimoButtons.vue')
  },
  props: {
    headingData: {
      type: Object as PropType<HeadingData>,
      required: true
    },
    sectionData: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const areButtonsExist = computed(
      () => props.sectionData?.buttonCollection?.items?.length
    );

    return {
      areButtonsExist
    };
  }
});
